var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.74212 36.0164H11.9387V17.9546H16.9725L17.5027 11.9028H11.9434V8.45928C11.9434 7.04248 12.253 6.47013 13.6229 6.47013H17.5074V0.197754H12.5204C7.12534 0.197754 4.74212 2.53875 4.74212 7.08939V11.9028H0.989014V18.0391H4.74212V36.0164Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"18","height":"37","viewBox":"0 0 18 37","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
